import { List } from '../list'
import { useState, useEffect, useRef } from 'react'
import { Result } from '../result'
import { CSSTransition } from 'react-transition-group'

import c from './assets/sass/game.module.scss'

export const Game = ({
    hasBet,
    onPlayAgain,
    gameWon,
    gameLost,
    resetKey,
    cells,
    onCellClick,
    isRevealing,
}) => {
    const [hasResult, setHasResult] = useState(false)
    const [gameResult, setGameResult] = useState('lose')
    const loseTimerRef = useRef(null)

    useEffect(() => {
        if (hasBet && !gameLost && !gameWon) {
            setHasResult(false)
            setGameResult('lose')
        }
    }, [hasBet, gameLost, gameWon])

    useEffect(() => {
        if (gameWon) {
            setGameResult('win')
            setHasResult(true)
        }
    }, [gameWon])

    useEffect(() => {
        if (gameLost) {
            setGameResult('lose')
            loseTimerRef.current = setTimeout(() => {
                setHasResult(true)
            }, 2000)
        }
        return () => {
            if (loseTimerRef.current) clearTimeout(loseTimerRef.current)
        }
    }, [gameLost])

    return (
        <div className={c.component}>
            <List
                hasBet={hasBet}
                cells={cells}
                onCellClick={onCellClick}
                isRevealing={isRevealing}
                gameLost={gameLost}
            />
            <CSSTransition
                in={hasResult}
                timeout={300}
                classNames={{
                    enter: c.enter,
                    enterActive: c.enterActive,
                    exit: c.exit,
                    exitActive: c.exitActive,
                }}
                unmountOnExit
            >
                <Result type={gameResult} onPlayAgain={onPlayAgain} />
            </CSSTransition>
        </div>
    )
}
